import { useEffect, useState } from 'react'
import { getSessionStats } from '../../shared/api'

// Load weekly + total session stats for the header (server caches the result for 10 min)
export default function SessionStats() {
  const [stats, setStats] = useState(null)

  useEffect(() => { getSessionStats().then(setStats) }, [])

  if (!stats) return null

  return (
    <span className="page-stats">
      <span className="page-stat"><b>{stats.weekly}</b> this week</span>
      <span className="page-stat"><b>{stats.total}</b> total</span>
    </span>
  )
}
